Worker.prototype.newFn = () => {
    console.log(newFn);
};